/*
 * 模块: MetricHeader
 * 职责: 渲染指标卡片的头部信息（图标、标题、标签、描述）
 * 依赖: antd组件、类型定义、工具函数
 * 导出: MetricHeader组件
 * 限制: 文件<280行, 函数<30行
 */

import React from 'react';
import { Space, Tag, Typography } from 'antd';
import type { MetricDefinition } from '../../../types';
import { getCategoryIcon, getCategoryColor, getCategoryLabel } from '../utils/categoryHelpers';

const { Title, Paragraph } = Typography;

interface MetricHeaderProps {
  definition: MetricDefinition;
}

export const MetricHeader: React.FC<MetricHeaderProps> = ({ definition }) => {
  const IconComponent = getCategoryIcon(definition.category);
  
  return (
    <div className="metric-header" style={{ marginBottom: 24 }}>
      <Space size="large" align="start">
        <div 
          className="metric-icon-wrapper" 
          style={{ 
            background: `${getCategoryColor(definition.category)}15`,
            width: 64,
            height: 64,
            borderRadius: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 28
          }}
        >
          <IconComponent />
        </div>
        <div style={{ flex: 1 }}>
          <Space align="center">
            <Title level={2} style={{ margin: 0 }}>
              {definition.name}
            </Title>
            <Tag 
              color={getCategoryColor(definition.category)}
              style={{ fontSize: '14px', padding: '4px 16px' }}
            >
              {getCategoryLabel(definition.category)}
            </Tag>
          </Space>
          <Paragraph style={{ marginTop: 8, marginBottom: 0, fontSize: '16px', color: '#595959', textAlign: 'left' }}>
            {definition.short_desc}
          </Paragraph>
        </div>
      </Space>
    </div>
  );
};

